"use client"

import { motion } from "framer-motion"

export default function ClientsSectionMinimal() {
    const clients = ["TikTok", "Temu", "AliExpress", "Cainiao"]

    return (
        <section className="container mx-auto px-4 py-20">
            <div className="border-border/70 border-t pt-12 dark:border-border/40">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
                    {/* Section Header */}
                    <div className="lg:col-span-3">
                        <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                            Global Impact
                        </span>
                    </div>

                    {/* Content */}
                    <div className="flex flex-col gap-12 lg:col-span-9">
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                            className="max-w-3xl font-light text-muted-foreground text-xl leading-relaxed md:text-3xl"
                        >
                            Shipped features for some of the{" "}
                            <span className="font-normal text-foreground">
                                largest platforms
                            </span>{" "}
                            on the web.
                        </motion.p>

                        <div className="grid grid-cols-2 gap-px bg-border/70 sm:grid-cols-4 dark:bg-border/40">
                            {clients.map((client, index) => (
                                <motion.div
                                    key={client}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{
                                        delay: index * 0.1,
                                        duration: 0.5,
                                    }}
                                    viewport={{ once: true }}
                                    className="group relative flex aspect-2/1 items-center justify-center bg-background"
                                >
                                    <span className="relative z-10 font-medium text-lg text-muted-foreground transition-colors duration-300 group-hover:text-foreground sm:text-xl">
                                        {client}
                                    </span>
                                    <div className="absolute inset-0 bg-muted/0 transition-colors duration-300 group-hover:bg-muted/50" />
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
